
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom'
import Footer from "../components/footer"
import ProgressBar from "../components/assessment/progress-ber"
import { questionList } from '../assets/list/questionList'

const Assessment = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const p = searchParams.get("p");
  const setColor = Number(p) < 8 ? 'yellow' : 'green';
  const [answer, setAnswer] = useState('');
  const [isChecked, setIsChecked] = useState(false)
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)

  useEffect(() => {
    setIsSubmitDisabled(true)
    if (!isChecked) return
    setIsSubmitDisabled(false)
  }, [isChecked])

  const onChangeCheckbox = (value:string) => {
    setAnswer(value)
    if (!isChecked) {
      setIsChecked(!isChecked)
    }
  }
  const handleSave = () => {
    localStorage.setItem(`Answer${p}`, answer);
    navigate(
      Number(p) === 12
      ? `../nanineko/result`
      : `/nanineko/assessment?p=${Number(p) + 1}`
    )
    setIsChecked(!isChecked)

  }

  return (
    <div>
      {questionList.map((question) => (
         Number(p) === question.id &&
          <div className={`assessment stripe-${setColor}`}>
            <div className="margin_pc">
              <ProgressBar />
              <div className="question">
                <div className="question_text anime_poyon">
                  <h3>Q{question.id}</h3>
                  <h2>{question.question}</h2>
                </div>
                <div className="questionimg_sp sp anime_poyon">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/cat/question/cat_sp_${question.cat_l}.png`}
                    alt={String(question.id)}
                    className="questionimg_sp_l"
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/img/cat/question/cat_sp_${question.cat_r}.png`}
                    alt={String(question.id)}
                    className="questionimg_sp_r"
                  />
                </div>
                <div className="questionimg_pc pc anime_poyon">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/cat/question/cat_pc_${question.cat_l}.png`}
                    alt={String(question.id)}
                    className="questionimg_pc_l"
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/img/cat/question/cat_pc_${question.cat_r}.png`}
                    alt={String(question.id)}
                    className="questionimg_pc_r"
                  />
                </div>
                <div className="question_img"></div>
              </div>
              <div className={`assessment-form as-${setColor}`}>
                <input 
                  type="radio"name="qa_1" value="1" id="1" onChange={(e) => onChangeCheckbox(e.target.value)}
                /><label htmlFor="1">はい</label>
                <input type="radio" name="qa_1" value="0" id="2" onChange={(e) => onChangeCheckbox(e.target.value)}
                  /><label htmlFor="2">いいえ</label>
                <input type="radio" name="qa_1" value="0" id="3" onChange={(e) => onChangeCheckbox(e.target.value)}
                  /><label htmlFor="3">わからない</label>
                <button className="btn_next" onClick={ handleSave } disabled={isSubmitDisabled}></button>
              </div>
            </div>
          </div>
        ))}
      <Footer />
    </div>
  )
}
  
  export default Assessment